import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import ManufacturingMaster2Tables from "./ShiftAndChangeoverTable";
import btnDownloadIcon from ".././../../Assests/download.svg";
import {
  ViewProductTableError,
  ViewProductTableStart,
  EditProductTableSuccess,
  ViewProductTableSuccess,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  MEDIUM_HOME_SHIFTCHANGEOVER_GETALL,
  BUILK_EDIT_MEDIUM_HOME_SHIFTCHANGEOVER_UPDATEBYIDS,
  MEDIUM_HOME_SHIFTCHANGEOVER_GETALLDOWNLOAD,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import * as actions from "../../../Redux/Actions/index";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import btnSaveIcon from "../../../Assests/Save-btn.svg";

import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function MediumShiftAndChangeover(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectCascade, setSelectCascade] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [capacityOptions, setCapacityOptions] = useState<any>([]);
  const [selectCapacity, setSelectCapacity] = useState<any>("");

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "cascade_No", value: "" },
    { key: "line", value: "" },
    { key: "capacity", value: "" },
  ]);

  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const sortedFactoryNames = factoryOptions?.sort((a: any, b: any) =>
    a?.factory_Name.localeCompare(b?.factory_Name)
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  var line = 0;
  var capacity = 0;

  /**Redux state */

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  /**Redux state */

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage
  );

  useEffect(() => {
    // if(selectedUsecaseId === 2 && selectedCategoryId === 1) {
    //   callTableGridApi();
    //  }
    callTableGridApi();
    getfiltersApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
  ]);

  const handleChangeSelectFactory = (event: any) => {
    setSelectLine("");
    setSelectCapacity("");

    filterRequest[2].value = "";
    filterRequest[3].value = "";
    capacity = 0;
    line = 0;
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    filterRequest[0].value = value;
    callTableGridApi();
  };

  const handleChangeSelectCascade = (event: any) => {
    setSelectCapacity("");

    const {
      target: { value },
    } = event;
    setSelectCascade(value);
    filterRequest[1].value = value;
    callTableGridApi();
  };

  const handleChangeSelectLine = (event: any) => {
    setSelectCapacity("");
    capacity = 0;
    line = 1;
    const {
      target: { value },
    } = event;
    setSelectLine(value);
    filterRequest[3].value = "";
    filterRequest[2].value = value;
    callTableGridApi();
  };
  const callTableGridApi = (resetfilter?: any) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: "tblScenario_ShiftChangeover_Add_HCMT",
      time_period: "string",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: resetfilter ? resetfilter : filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + MEDIUM_HOME_SHIFTCHANGEOVER_GETALL;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        let filterIndex = response.data.length - 1;
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);
          dispatch(ViewProductTableSuccess(response.data));
          // setFactoryOptions(response.data[filterIndex].filter_values.Factory);
          // setCascadeOptions(response.data[filterIndex].filter_values["Cascade No"]);
          // setLineOptions(response.data[filterIndex].filter_values.Line);
          if (factoryOptions.length === 0)
            setFactoryOptions(loadFactoryOptions(response.data));
          if (line === 0) setLineOptions(loadLineOptions(response.data));
          if (capacity === 0)
            setCapacityOptions(loadCapacityOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const getfiltersApi = () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing2Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList};
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: "tblScenario_ShiftChangeover_Add_HCMT",
      time_period: "string",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + MEDIUM_HOME_SHIFTCHANGEOVER_GETALL;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setFactoryOptions(response.data.factoryFilter);
          setLineOptions(response.data.lineFilter);
          setCascadeOptions(response.data.cascade_NoFilter);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadCapacityOptions = (data: any) => {
    console.log(data, "dateeeeeeeee");
    const capacityOptions: any = [];
    data.map((item: any) => {
      const filteredItem = capacityOptions.find((obj: any) => {
        return obj.capacity === item.capacity;
      });
      if (filteredItem === undefined || filteredItem == null) {
        capacityOptions.push({ id: item.id, capacity: item.capacity });
      }
    });
    return capacityOptions;
    //setTimePeriodOptions(timePeriodPackOptions);
  };
  const loadLineOptions = (data: any) => {
    const lineOptions: any = [];
    data.map((item: any) => {
      const filteredItem = lineOptions.find((obj: any) => {
        return obj.line === item.line;
      });
      if (filteredItem === undefined || filteredItem == null) {
        lineOptions.push({ id: item.id, line: item.line });
      }
    });
    return lineOptions;
  };

  const loadFactoryOptions = (data: any) => {
    console.log(data, "dateeeeeeeee");
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.factory_Name === item.factory;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({ id: item.id, factory_Name: item.factory });
      }
    });
    return factoryOptions;
    //setTimePeriodOptions(timePeriodPackOptions);
  };

  const handleChangeSelectCapacity = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectCapacity(value);
    filterRequest[3].value = value;
    callTableGridApi();
    line = 1;
    capacity = 1;
    // base = 1;
    // time = 1;
  };
  const handleRestoreClicked = (e: any) => {
    setSelectFactory("");
    setSelectCascade("");
    setSelectCapacity("");

    setSelectLine("");
    callTableGridApi([]);
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing2Data", "filter": filterList };
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: "tblScenario_ShiftChangeover_Add_HCMT",
      time_period: "string",
      filter: filterList,
    };
    const urls = API_BASE_URL + MEDIUM_HOME_SHIFTCHANGEOVER_GETALLDOWNLOAD;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "factory_Code",
      "factory",
      "cascade",
      "line",
      "max_no_of_shifts",
      "max_no_of_changeovers",
      "changeover_Shift",
      "capacity",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        usecaseId: 2,
        category_Id: 1,
        user_Id: 1,
        factory_Code: "",
        factory: "",
        cascade: "",
        line: "",
        max_no_of_shifts: 0,
        max_no_of_changeovers: 0,
        changeover_Shift: 0,
        capacity: "",
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls =
      API_BASE_URL + BUILK_EDIT_MEDIUM_HOME_SHIFTCHANGEOVER_UPDATEBYIDS;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    putRequest(urls, transformedRows, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
    setTimeout(() => {
      //props?.onClose();
    }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);
  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited Shift&Changeover table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Shift And Changeover"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Shift & Changeover</h3>
          </div>
          <div className="filters">
            <RestoreOutlinedIcon
              className="restoreIcon"
              onClick={(e) => handleRestoreClicked(e)}
            />
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Factory</em>
                  </MenuItem>
                  {sortedFactoryNames?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.factory_Name}>
                        {d.factory_Name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <InputLabel>Cascade</InputLabel>
                <Select
                  id="simple-select-2"
                  value={selectCascade}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectCascade}
                  className="select-short-term">
                  {cascadeOptions.map((d: any) => {
                    return (<MenuItem key={d} value={d.cascade_No}>{d.cascade_No}</MenuItem>)
                  })}
                </Select>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Line</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectLine}
                  placeholder="Select Line"
                  onChange={handleChangeSelectLine}
                  // renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Line</em>
                  </MenuItem>
                  {lineOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.line}>
                        {d.line}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            {/* {selectedScenarioId > 0 ?  */}

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Capacity</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectCapacity}
                  placeholder="Select Capacity"
                  onChange={handleChangeSelectCapacity}
                  // renderValue={(selectCapacity: any) => selectCapacity}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Capacity</em>
                  </MenuItem>
                  {capacityOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.capacity}>
                        {d.capacity}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* : ""} */}

            {isEditEnabled && isEditPopup && (
              <div className="filter-item">
                <FormControl fullWidth>
                  <div
                    className="content-save-btn"
                    onClick={(e) => handleEditSave(e)}
                  >
                    <img src={btnSaveIcon} alt="" /> <span> Save</span>
                  </div>
                </FormControl>
              </div>
            )}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={handleDownload}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <ManufacturingMaster2Tables
          isProcessed={isProcessed}
          rowsData={rowsData}
          ref={childRef}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default MediumShiftAndChangeover;
